import { render, staticRenderFns } from "./ProfileChangeNotifications.vue?vue&type=template&id=9e0f0a5e&scoped=true"
import script from "./ProfileChangeNotifications.vue?vue&type=script&lang=js"
export * from "./ProfileChangeNotifications.vue?vue&type=script&lang=js"
import style0 from "./ProfileChangeNotifications.vue?vue&type=style&index=0&id=9e0f0a5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e0f0a5e",
  null
  
)

export default component.exports